import isEmpty from "lodash/isEmpty";
import React, { useMemo } from "react";
import { IOvInvestigation } from "../models/overage";

interface OverageInvestigationTemplateProps {
  investigationValues?: IOvInvestigation;
  osdNumber?: number;
  exceptionType?: string;
}

const OverageInvestigationTemplate: React.FC<
  OverageInvestigationTemplateProps
> = ({
  investigationValues,
  osdNumber,
  exceptionType,
}: OverageInvestigationTemplateProps): JSX.Element => {
  const values = useMemo(() => investigationValues, [investigationValues]);

  const getYesNoValue = (key: keyof IOvInvestigation) => {
    return (
      <div
        style={{
          width: "15vw",
          display: "inline-block",
          verticalAlign: "top",
        }}
      >
        {values?.[key] === "Y" ? "Yes" : "No"}
      </div>
    );
  };

  const getResponseValues = (key: keyof IOvInvestigation) => {
    return (
      <div
        style={{
          width: "75%",
          margin: "0 0 0 0",
          display: "inline-block",

          background: "#f5f7fb",
          padding: "10px",
          border: "1px solid #b5b6b9",
        }}
      >
        {values?.[key]}
      </div>
    );
  };
  return (
    <div>
      {values && !isEmpty(values) && (
        <div style={{ width: "100%", fontFamily: "calibri" }}>
          <div
            style={{
              width: "100vw",
              background: "#f5f7fb",
              padding: "10px 10px 15px",
              lineHeight: "40px",
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "15px",
              textTransform: "uppercase",
            }}
          >
            Overage Investigation{" "}
            <span
              style={{
                background: "#f5f5f5",
                border: "1px solid #d4d4d4",
                padding: "5px 15px",
                borderRadius: "20px",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              #{osdNumber}
            </span>
          </div>
          {/* NB Q1 Starts*/}
          <div
            style={{
              width: "calc(100vw - 40px)",
              margin: "0 20px 20px",
              display: "inline-block",
            }}
          >
            <div style={{ margin: "0 0 10px" }}>
              Was OD400 created by the dock?
            </div>
            <div>
              {getYesNoValue("od400Check")}
              {getResponseValues("od400CheckResponse")}
            </div>
          </div>
          {exceptionType === "NB" && (
            <>
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you utilize the markings off of the freight to find the
                  PRO# that may apply?
                </div>
                <div>
                  {getYesNoValue("markingsCheck")}
                  {getResponseValues("markingsCheckResponse")}
                </div>
              </div>
              {/* Q1 Ends*/}

              {/* NB Q2 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you view the trailer history?
                </div>

                <div>
                  {getYesNoValue("thCheck")}
                  {getResponseValues("thCheckResponse")}
                </div>
              </div>
              {/* Q2 Ends*/}

              {/* NB Q3 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  If freight was found on a manifest, did you search that
                  manifest for other shipments marked as short or undelivered?
                </div>

                <div>
                  {getYesNoValue("mfCheck")}
                  {getResponseValues("mfCheckResponse")}
                </div>
              </div>
              {/* Q3 Ends*/}

              {/* NB Q4 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you check the OS&D master reporting for descriptions of
                  open shortages and ADE's where the overage may apply?
                </div>

                <div>
                  {getYesNoValue("osAndDCheck")}
                  {getResponseValues("osAndDCheckResponse")}
                </div>
              </div>
              {/* Q4 Ends*/}

              {/* NB Q5 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you google search the Manufacturer, distributor and/or
                  product information? If so, did you use that information in
                  freight bill tracing and/or OS&D searches?
                </div>

                <div>
                  {getYesNoValue("googleCheck")}
                  {getResponseValues("googleCheckResponse")}
                </div>
              </div>
              {/* Q5 Ends*/}

              {/* NB Q6 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you check the unmanifested outbound and inbound freight
                  reports to see if overage may match a non-movement shipment?
                </div>

                <div>
                  {getYesNoValue("unmanifestedCheck")}
                  {getResponseValues("unmanifestedCheckResponse")}
                </div>
              </div>
              {/* Q6 Ends*/}

              {/* NB Q7 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you search undelivered outbound and inbound shipments by
                  shipper or account code that have not been delivered?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",

                      verticalAlign: "top",
                    }}
                  >
                    {values.undeliveredCheck === "Y" ? "Yes" : "No"}
                  </div>
                  <div
                    style={{
                      width: "75%",
                      margin: "0 0 0 0",
                      display: "inline-block",

                      background: "#f5f7fb",
                      padding: "10px",
                      border: "1px solid #b5b6b9",
                    }}
                  >
                    {values.undeliveredCheckResponse}
                  </div>
                </div>
              </div>
              {/* Q7 Ends*/}

              {/* NB Q8 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you use the customer delivery analysis report to check
                  shipments picked up or going to a specific account code during
                  a specific time frame?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",

                      verticalAlign: "top",
                    }}
                  >
                    {values.customerDeliveryCheck === "Y" ? "Yes" : "No"}
                  </div>
                  <div
                    style={{
                      width: "75%",
                      margin: "0 0 0 0",
                      display: "inline-block",

                      background: "#f5f7fb",
                      padding: "10px",
                      border: "1px solid #b5b6b9",
                    }}
                  >
                    {values.customerDeliveryCheckResponse}
                  </div>
                </div>
              </div>
              {/* Q8 Ends*/}

              {/* NB Q9 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you check your undelivered and inventory reports for any
                  shipments not yet delivered?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",

                      verticalAlign: "top",
                    }}
                  >
                    {values.undelInvCheck === "Y" ? "Yes" : "No"}
                  </div>
                  <div
                    style={{
                      width: "75%",
                      margin: "0 0 0 0",
                      display: "inline-block",

                      background: "#f5f7fb",
                      padding: "10px",
                      border: "1px solid #b5b6b9",
                    }}
                  >
                    {values.undelInvCheckResponse}
                  </div>
                </div>
              </div>
              {/* Q9 Ends*/}

              {/* NB Q10 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you send APB to ALLOSD (If the overage value is greater
                  than $1,000)?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",

                      verticalAlign: "top",
                    }}
                  >
                    {values.apbCheck === "Y" ? "Yes" : "No"}
                  </div>
                  <div
                    style={{
                      width: "75%",
                      margin: "0 0 0 0",
                      display: "inline-block",

                      background: "#f5f7fb",
                      padding: "10px",
                      border: "1px solid #b5b6b9",
                    }}
                  >
                    {values.apbCheckResponse}
                  </div>
                </div>
              </div>
              {/* Q10 Ends*/}

              {/* NB Q11 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you monitor all ALL OSD e-mail for possible match?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",

                      verticalAlign: "top",
                    }}
                  >
                    {values.emailCheck === "Y" ? "Yes" : "No"}
                  </div>
                  <div
                    style={{
                      width: "75%",
                      margin: "0 0 0 0",
                      display: "inline-block",

                      background: "#f5f7fb",
                      padding: "10px",
                      border: "1px solid #b5b6b9",
                    }}
                  >
                    {values.emailCheckResponse}
                  </div>
                </div>
              </div>
            </>
          )}
          {/* Q11 Ends*/}

          {/* OV Q1 Starts*/}
          {exceptionType === "OV" && (
            <>
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Do you check the bill of lading for a billing error?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",

                      verticalAlign: "top",
                    }}
                  >
                    {values.billOfLadingCheck === "Y" ? "Yes" : "No"}
                  </div>
                  <div
                    style={{
                      width: "75%",
                      margin: "0 0 0 0",
                      display: "inline-block",

                      background: "#f5f7fb",
                      padding: "10px",
                      border: "1px solid #b5b6b9",
                    }}
                  >
                    {values.billOfLadingCheckResponse}
                  </div>
                </div>
              </div>
              {/* Q1 Ends*/}

              {/* OV Q2 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you check the DR to confirm what the consignee signed for?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",

                      verticalAlign: "top",
                    }}
                  >
                    {values.drCheck === "Y" ? "Yes" : "No"}
                  </div>
                  <div
                    style={{
                      width: "75%",
                      margin: "0 0 0 0",
                      display: "inline-block",

                      background: "#f5f7fb",
                      padding: "10px",
                      border: "1px solid #b5b6b9",
                    }}
                  >
                    {values.drCheckResponse}
                  </div>
                </div>
              </div>
              {/* Q2 Ends*/}

              {/* OV Q3 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  If a packing slip was found, did you check the packing slip to
                  determine what the shipment consisted of?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",

                      verticalAlign: "top",
                    }}
                  >
                    {values.psCheck === "Y" ? "Yes" : "No"}
                  </div>
                  <div
                    style={{
                      width: "75%",
                      margin: "0 0 0 0",
                      display: "inline-block",

                      background: "#f5f7fb",
                      padding: "10px",
                      border: "1px solid #b5b6b9",
                    }}
                  >
                    {values.psCheckResponse}
                  </div>
                </div>
              </div>
              {/* Q3 Ends*/}

              {/* OV Q4 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you reach out to the consignee to verify what they
                  received on their delivery?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",

                      verticalAlign: "top",
                    }}
                  >
                    {values.consigneeCheck === "Y" ? "Yes" : "No"}
                  </div>
                  <div
                    style={{
                      width: "75%",
                      margin: "0 0 0 0",
                      display: "inline-block",

                      background: "#f5f7fb",
                      padding: "10px",
                      border: "1px solid #b5b6b9",
                    }}
                  >
                    {values.consigneeCheckResponse}
                  </div>
                </div>
              </div>
              {/* Q4 Ends*/}

              {/* OV Q5 Starts*/}
              <div
                style={{
                  width: "calc(100vw - 40px)",
                  margin: "0 20px 20px",
                  display: "inline-block",
                }}
              >
                <div style={{ margin: "0 0 10px" }}>
                  Did you check same day shipments at time of pickup to see if
                  any are short and/or have ADE's that could have caused a
                  misdelivery for your overage?
                </div>

                <div>
                  <div
                    style={{
                      width: "15vw",
                      display: "inline-block",

                      verticalAlign: "top",
                    }}
                  >
                    {values.shipmentCheck === "Y" ? "Yes" : "No"}
                  </div>
                  <div
                    style={{
                      width: "75%",
                      margin: "0 0 0 0",
                      display: "inline-block",

                      background: "#f5f7fb",
                      padding: "10px",
                      border: "1px solid #b5b6b9",
                    }}
                  >
                    {values.shipmentCheckResponse}
                  </div>
                </div>
              </div>
            </>
          )}
          {/* Q5 Ends*/}
        </div>
      )}
    </div>
  );
};

export default OverageInvestigationTemplate;
